import React from 'react';
import { IconSvgProps } from '@models/common';

const ImproveText: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10.6176 1.95081C11.5653 1.00313 13.1019 1.00313 14.0496 1.95081C14.9973 2.89848 14.9973 4.43517 14.0496 5.38284L4.87148 14.561C4.72902 14.7034 4.53545 14.7835 4.33398 14.7836H2.00039C1.58065 14.7836 1.24023 14.4432 1.24023 14.0235V11.643C1.24023 11.4414 1.32037 11.248 1.46289 11.1055L10.6176 1.95081ZM2.76055 11.9578V13.2633H4.01914L11.4371 5.84534L10.1551 4.56331L2.76055 11.9578ZM12.9746 3.02581C12.6205 2.67173 12.0467 2.67173 11.6926 3.02581L11.2301 3.48831L12.5121 4.77034L12.9746 4.30784C13.3287 3.95377 13.3287 3.37988 12.9746 3.02581Z'
        fill='currentColor'
      />
      <path
        d='M12.0565 10.7525C12.1044 10.6231 12.2876 10.6231 12.3355 10.7525L12.8149 12.0483C12.8224 12.0684 12.8341 12.0867 12.8492 12.1019C12.8643 12.117 12.8826 12.1288 12.9027 12.1362L14.1986 12.6157C14.328 12.6636 14.328 12.8468 14.1986 12.8947L12.9028 13.3742C12.8827 13.3816 12.8645 13.3933 12.8493 13.4084C12.8341 13.4236 12.8224 13.4418 12.8149 13.4619L12.3355 14.7577C12.2876 14.8872 12.1044 14.8872 12.0565 14.7577L11.577 13.4621C11.5696 13.442 11.5579 13.4237 11.5427 13.4085C11.5276 13.3933 11.5094 13.3816 11.4893 13.3742L10.1933 12.8947C10.0639 12.8468 10.0639 12.6636 10.1933 12.6157L11.4891 12.1362C11.5092 12.1288 11.5275 12.1171 11.5427 12.102C11.5578 12.0868 11.5695 12.0686 11.577 12.0485L12.0565 10.7525Z'
        fill='currentColor'
      />
      <path
        d='M3.27848 1.04931C3.33577 0.894533 3.55495 0.894533 3.61224 1.04931L4.18581 2.59942C4.19469 2.62348 4.20867 2.64533 4.22679 2.66348C4.2449 2.68162 4.26673 2.69564 4.29077 2.70457L5.84104 3.27814C5.99582 3.33543 5.99582 3.55461 5.84104 3.61189L4.29095 4.18547C4.26689 4.19435 4.24504 4.20833 4.2269 4.22645C4.20875 4.24457 4.19473 4.2664 4.18581 4.29044L3.61224 5.84054C3.55495 5.9955 3.33577 5.9955 3.27848 5.84054L2.70492 4.29061C2.69603 4.26656 2.68205 4.24471 2.66393 4.22656C2.64582 4.20841 2.62399 4.19439 2.59995 4.18547L1.04968 3.61189C0.894899 3.55461 0.894899 3.33543 1.04968 3.27814L2.59977 2.70457C2.62383 2.69568 2.64568 2.6817 2.66383 2.66358C2.68197 2.64547 2.69599 2.62364 2.70492 2.5996L3.27848 1.04931Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default ImproveText;
